import React from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { useSelector } from 'react-redux';
import { State } from './store';

export default function IntercomWidget() {
  const username = useSelector((state: State) => state.auth.username);
  const user_id = useSelector((state: State) => state.auth.user_id);
  const name = useSelector((state: State) => state.auth.name);
  const email = useSelector((state: State) => state.auth.email);
  const user_hash = useSelector((state: State) => state.auth.user_hash);

  if (!user_id || !username || !name || !email || !user_hash) {
    return null;
  }

  Intercom({
    app_id: 'ltcafuzd',
    user_id,
    name,
    email,
    user_hash,
  });

  return <React.Fragment />;
}
